import { queryOptions, useQuery } from '@tanstack/react-query';

import { getAccessToken } from '@/lib/tokenStorage';
import { queryClient } from '@/services/api/query/queryClient';

export function featureFlagsQueryOptions() {
  return queryOptions({
    queryKey: ['featureFlags'],
    async queryFn() {
      const token = getAccessToken();
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/api/features`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          credentials: 'include',
        },
      );

      if (!response.ok) {
        throw new Error('HTTP Error');
      }

      const flags = await response.json();
      return flags as Record<string, boolean | undefined>;
    },
    meta: { persist: true },
  });
}

export function useFeatureFlags() {
  const flags = useQuery(featureFlagsQueryOptions());
  return flags.data ?? {};
}

export function useFeatureFlag(flagName: string): boolean {
  const flags = useFeatureFlags();
  return flags[flagName] ?? false;
}

export function getFeatureFlag(flagName: string): boolean {
  const flags = queryClient.getQueryData<Record<string, boolean | undefined>>(
    featureFlagsQueryOptions().queryKey,
  );
  return flags?.[flagName] ?? false;
}
